<template>
    <div class="fillcontain">
        <div class="table_container">
            <el-row>
                <el-button type="primary" @click="handleEdit(0, '','add')">新增员工</el-button>
            </el-row>
            <br/>
            <el-table
                :data="userTableData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column
                label="姓名"
                prop="name">
              </el-table-column>

              <el-table-column
                label="账号"
                prop="user.account">
              </el-table-column>

              <el-table-column
                label="编号"
                prop="number">
              </el-table-column>

              <el-table-column
                label="电话"
                prop="telephones">
              </el-table-column>
              <el-table-column
                label="角色"
                prop="role.name">
              </el-table-column>

                <el-table-column
                    label="备注"
                    prop="note"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="状态"
                    :formatter="rreezeFormat">
                </el-table-column>

                <el-table-column label="操作" width="350">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      v-if="scope.row.user.belong == 3"
                      @click="handleEdit(scope.$index, scope.row,'edit')">
                        编辑
                    </el-button>
                    <el-button
                      size="mini"
                      type="warning"
                      v-if="scope.row.user.belong == 3"
                      @click="handleResetPwdAlert( scope.row)">
                      密码
                    </el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      v-if="scope.row.user.belong == 3"
                      @click="handleDeleteAlert( scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pages.page"
                  :page-size="pages.pageSize"
                  layout="total, prev, pager, next"
                  :total="pages.total">
                </el-pagination>
            </div>



            <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
                <el-form :model="admin">

                  <el-form-item label="账号" label-width="100px"  v-if="admin.id == 0">
                    <el-input v-model="admin.account" auto-complete="off">
                      <template slot="prepend">{{storePrefix}}</template>
                    </el-input>
                    <br/>
                    <el-alert v-if="admin.account != ''"
                              :title="'帐号为：'+storePrefix+admin.account"
                              type="success"
                              :closable="false"
                    >
                    </el-alert>
                  </el-form-item>
                  <el-form-item label="账号" label-width="100px" v-else>
                    {{admin.account}}
                  </el-form-item>
                  <el-form-item label="密码" label-width="100px" v-if="admin.id == 0">
                    <span>初始密码为：888888</span>
                  </el-form-item>
                    <el-form-item label="姓名" label-width="100px">
                        <el-input v-model="admin.name" auto-complete="off"></el-input>
                    </el-form-item>
                  <el-form-item label="编号" label-width="100px">
                    <el-input v-model="admin.number" auto-complete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="电话" label-width="100px">
                    <el-input v-model="admin.telephones" auto-complete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="性别" label-width="100px">
                    <el-switch
                      v-model="admin.sex"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="男"
                      inactive-text="女"
                      active-value="1"
                      inactive-value="2">
                    </el-switch>
                  </el-form-item>

                  <el-form-item label="生日" label-width="100px">
                    <el-date-picker
                      v-model="admin.birthday"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择生日">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label="状态" label-width="100px">

                    <el-switch
                      v-model="admin.isFreeze"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="正常"
                      inactive-text="冻结"
                      active-value="0"
                      inactive-value="1">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="角色" label-width="100px">
                  <el-select v-model="admin.role_id" placeholder="角色" style="width:100%;" >
                    <el-option
                      v-for="item in roles"
                      :key=item.id
                      :label="item.name"
                      :value=item.id>
                    </el-option>
                  </el-select>
                  </el-form-item>
                  <el-form-item label="备注" label-width="100px">
                    <el-input v-model="admin.note" type="textarea" rows="4"></el-input>
                  </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleSave">确 定</el-button>
                </div>
            </el-dialog>


        </div>

    </div>
</template>

<script>
    export default {
        data(){
            return {
                loading:false,
                admin:{
                    id:0,
                    account:"",
                    name:"",
                    number:"",
                    sex:"1",
                    birthday:"",
                    telephones:"",
                    note:"",
                    isFreeze:"0",
                    role_id:0,
                },
                dialog:{
                    dialogFormVisible:false,
                    title:"新增员工",
                    close:false,
                },
                pages:{
                    offset: 0,
                    pageSize: 10,
                    page: 1,
                    total: 0,
                },
                userTableData: [],
                storePrefix:"",
                login_url:"",
                qrcodeurl:"",
                wx_login_url:null,
                roles:[],
            }
        },
        created(){
            var storage = window.localStorage;
            var user = JSON.parse(storage["user"]);
            console.log("=========");
            console.log(user);
            this.storePrefix = user.mainStore.storePrefix;
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/main_store/user', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.userTableData = res.data.store_users.content;
                    that.login_url = res.data.login_url;
                    //that.wx_login_url = window.server.baseUrl,+'/common/qrCode?content='+encodeURIComponent(res.data.wx_login_url);
                    that.pages.total = res.data.store_users.totalElements;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages.page = val;
                this.pages.offset = (val - 1)*this.pages.pageSize;
                this.initData()
            },
            rreezeFormat(row,column){
                return ""+row.user.isFreeze == "1"?"冻结":"正常";
            },






            handleEdit(index, row,action) {
                if(action == "edit"){
                    this.dialog.title = "修改员工:"+this.admin.name
                    this.admin.id = row.id;
                    this.admin.account = row.user.account;
                    this.admin.name = row.name;
                    this.admin.number = row.number;
                    this.admin.sex = ""+row.sex;
                    this.admin.birthday = new Date(row.birthday);
                    this.admin.telephones = row.telephones;
                    this.admin.note = row.note;
                    this.admin.role_id = row.role.id;
                    this.admin.isFreeze = ""+row.user.isFreeze;
                    this.dialog.dialogFormVisible = true;
                }else if(action == "add"){
                    this.dialog.title = "新增员工";
                    this.admin.id = 0;
                    this.admin.account ="";
                    this.admin.name = "";
                    this.admin.number = "";
                    this.admin.sex = "1";
                    let date = new Date()
                    this.admin.birthday = this.dateFormat("YYYY-mm-dd HH:MM:SS", date);
                    this.admin.telephones = "";
                    this.admin.note = "";
                    this.admin.role_id = 0;
                    this.admin.isFreeze = "1";
                    this.dialog.dialogFormVisible = true;
                }

              this.initRolesData();
            },
            initRolesData(){
              this.loading = true;
              var that = this;
              that.$api.get('/main_store/role', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.roles = res.data.role;
                    if(this.admin.role_id == 0 && that.roles.length > 0){
                      this.admin.role_id = that.roles[0].id
                    }

                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },
            dateFormat(fmt, date) {
                let ret;
                const opt = {
                  "Y+": date.getFullYear().toString(),        // 年
                  "m+": (date.getMonth() + 1).toString(),     // 月
                  "d+": date.getDate().toString(),            // 日
                  "H+": date.getHours().toString(),           // 时
                  "M+": date.getMinutes().toString(),         // 分
                  "S+": date.getSeconds().toString()          // 秒
                  // 有其他格式化字符需求可以继续添加，必须转化成字符串
                };
                for (let k in opt) {
                  ret = new RegExp("(" + k + ")").exec(fmt);
                  if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                  };
                };
                return fmt;
            },
            handleSave() {
                this.loading = true;
                var that = this;
                that.$api.post('/main_store/user', that.admin, response => {
                  if (response.status >= 200 && response.status < 300) {
                    console.log(response.data);
                    var res = response.data;
                    if (res.code == 0) {
                      this.$message({
                        message: that.dialog.title+'成功',
                        type: 'success'
                      });
                      this.dialog.dialogFormVisible = false;
                      this.initData();
                    }else{
                      this.$message({
                        message: res.msg,
                        type: 'warning'
                      });
                    }
                  } else {
                    this.$message({
                      message: "服务器维护中",
                      type: 'error'
                    });
                  }

                });

                this.loading = false;
            },
            handleResetPwdAlert(row) {
              this.$confirm('此操作将重置该员工的密码为:888888, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.handleResetPwd(row);
              }).catch(() => {

              });
            },

            handleResetPwd(row) {
              this.loading = true;
              var that = this;
              that.$api.put('/main_store/user/reset_password/'+row.id, null, response => {
                if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: '重置成功,请立即使用默认密码:888888 登录修改密码',
                      type: 'success',

                    });
                    //this.initData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }

                this.loading = false;

              });
            },

            handleDeleteAlert(row) {
                this.$confirm('此操作将删除该员工, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleDelete(row);
                }).catch(() => {

                });
            },
          handleDelete(row) {
            this.loading = true;
            var that = this;
            that.$api.delete('/main_store/user/'+row.id, null, response => {
              if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.loading = false;
                    this.initData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
              } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
              }

            });
            },
        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/mainStore/StoreUser.vue